import { useUserModuleDispatch, USER_MODULE_ACTION } from ".."
import { useCallback } from "react";

export function useSetLastVisited() {

    const dispatch = useUserModuleDispatch();

    return useCallback((trackId: TrackId, nodeId: NodeId) => {
        dispatch({
            type: USER_MODULE_ACTION.SET_LAST_VISITED,
            payload: {
                trackId,
                nodeId
            }
        })
    }, [dispatch])
}
